<template>
  <el-input type="textarea" v-model="lastApprovalMemo" :disabled="true"></el-input>
</template>

<script>
export default {
  name: "JSLastApprovalMemo",
  data() {
    return {
      lastApprovalMemo: ""
    };
  },
  props: ["id"],
  mounted: function() {
    this.dataBind();
  },
  methods: {
    dataBind() {
      this.getLastApprovalMemo();
    },
    getLastApprovalMemo() {
      let that = this;
      rt
        .get(
          "../api/Approval/GetLastApprovalMemo?entityId=" +
            this.id
        )
        .then(function(res) {
          if (res != null && res.length > 0) {
            that.lastApprovalMemo = res;
          }
        })
        .catch(error => {
          rt.showErrorToast("获取捷顺最新签核意见失败:"+error);
        });
    },
  }
};
</script>


// WEBPACK FOOTER //
// LastApprovalMemo.vue?6c4608a1